let module = angular.module('app.directives.schedule', []);

require('./broadcast-overlay-configuration');
require('./broadcast-select-scoreboard-connection');
require('./broadcast-select-sport');
require('./broadcast-team-color-picker');
require('./fb-live-simulcast-settings');
require('./host-restrictions-settings');
require('./twitter-simulcast-settings');
require('./podcast-settings');
require('./recurrence-pattern');
require('./rtmp-simulcast-settings');
require('./scoreboard-config-summary');
require('./scoreboard-tab-config');
require('./simulcast-configuration-editor');
require('./youtube-live-simulcast-settings');

export default module;



// WEBPACK FOOTER //
// ./app/directives/schedule/index.js